import React from "react";
import { useTranslation } from "react-i18next";

/** The workspace's document types (feature 3, from GET /documents/upload-config).
 * The type picks the extraction pipeline on the backend. Hidden when the
 * workspace offers a single type; "" means "the workspace default" (the first
 * type), which the backend applies when no document_type is sent. */
export default function DocumentTypeSelect({ id, className, types, value, onChange, disabled }) {
  const { t } = useTranslation();
  if (!Array.isArray(types) || types.length < 2) return null;
  return (
    <div className={className}>
      <label htmlFor={id}>{t("upload.documentTypeLabel")}</label>
      <select
        id={id}
        className="ds-select"
        value={value || types[0].id}
        onChange={(e) => onChange(e.target.value === types[0].id ? "" : e.target.value)}
        disabled={disabled}
      >
        {types.map((type) => (
          <option key={type.id} value={type.id}>
            {type.label}
          </option>
        ))}
      </select>
    </div>
  );
}

/** Append the chosen type to an upload form (nothing for the default). */
export function appendDocumentType(formData, documentType) {
  if (documentType) formData.append("document_type", documentType);
}
